import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";
import moment from "moment";

class AdmissionsReq extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: "Admissões",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      labels: ["Pré-admitidos", "Admitidos", "Cobrados"],
    },
  };

  render() {
    return (
      <div class="ml-4 mt-3">
        {this.props.admissions && (
          <Chart
            title={this.state.title}
            options={this.state.chartOptions}
            series={[
              {
                name: "",
                data: [
                  this.props.admissions[0].pre_admitidos,
                  this.props.admissions[0].por_cobrar,
                  this.props.admissions[0].cobrados,
                ],
              },
            ]}
            type="bar"
            width="480"
            height="350"
          />
        )}

        <div class="subtitle-grafs mt-2 text-center">
          Dados referentes
          {this.props.filter_date_admissions == null ||
          this.state.filter_date_admissions ===
            moment().subtract(1, "month").format("YYYY-MM-DD") ? (
            <span> aos últimos 30 dias.</span>
          ) : (
            <span> ao intervalo de tempo selecionado no filtro</span>
          )}
        </div>
      </div>
    );
  }
}
export default AdmissionsReq;
